import { FOLLOWERS_LIGHTBOX } from '../ids';
import { InstallLocation } from '../types';
import { formatDescription } from '../utils';
export const ids = FOLLOWERS_LIGHTBOX;
export const getDefinition = (staticsUrl, t) => ({
    ...FOLLOWERS_LIGHTBOX,
    installLocation: InstallLocation.Lightbox,
    page: {
        name: t('member-pages.followers-lightbox.name'),
        shortDescription: t('member-pages.followers.short-description'),
        description: formatDescription({
            text: t('member-pages.followers.description.text'),
            bulletPoints: [
                t('member-pages.followers.description.bullet-point-1'),
                t('member-pages.followers.description.bullet-point-2'),
                t('member-pages.followers.description.bullet-point-3'),
                t('member-pages.followers.description.bullet-point-4'),
            ],
        }),
        iconURL: `${staticsUrl}assets/images/icons/members-area-icon.svg`,
        origin: t('member-pages.followers.origin'),
        screenshots: [
            `${staticsUrl}assets/images/followers/followers.png`,
            `${staticsUrl}assets/images/followers/mobile-followers.png`,
        ],
    },
});
//# sourceMappingURL=followers-lightbox.js.map